@if (index == 0 && retDash === false) {
  <span>{{'Find_0' | translate}}</span>
}
@if (index == 1) {
  <div class="display-block">
    @if (retDash === false) {
      <span>{{'Query' | translate}} {{ currentLabelRequest }} </span>
    }
    <div class="right">
      @if (displayListResult === true) {
        <button
          class="btnsize margin-left"
          type="button" pButton
          pTooltip="{{'Return_Res' | translate}}"
          tooltipPosition="left"
          icon="pi icons8-retour" styleClass="p-button-success"
          (click)="returnList()"
        ></button>
      }
    </div>
  </div>
  <displayresult
    #dispresult
    [srchMode]="srchMode"
    [resultDisplay]="resultDisplay"
    [btnAction]="true"
    [nbDoc]="nbDoc"
    [listColumns]="listColumns"
    [infoList]="infoList"
    [currentSelectedBsk]="{}"
    [listBskVariable]="[]"
    [basketMoveAll]="[]"
    [curPage]="curPage"
    [request]="currentRequest"
    [isDesktop]="isDesktop"
    [autoDocId]="autoDocId"
    [fetchParam]="fetchParam"
    (onReturnResult)="onReturnResult($event)"
    (onAction)="onAction($event)"
    (onNextDocs)="onNextDocs()"
    >
  </displayresult>
}

@if (displaySearch === true) {
  <filterdocs
    [visible]="displaySearch"
    (onFilter)="onClickSearch($event)"
    (onClose)="closeSearch()"
    >
  </filterdocs>
}